import { useState } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faXmark } from '@fortawesome/free-solid-svg-icons'
import Modal from 'react-modal';

function DepositHistory({history, index}) {
  const [modalIsOpen, setIsOpen] = useState(false);

  return (
    <>
        <tr className="fw-semibold">
            <td className="text-nowrap d-md-table-cell d-none">{history.date}</td>
            <td className="d-md-none d-table-cell">{index + 1}</td>
            <td className="d-md-table-cell d-none">#{history.hash}</td>
            <td className="d-md-table-cell d-none">{history.type}</td>
            <td className="d-md-table-cell d-none">{history.method}</td>
            <td className="d-md-table-cell d-none">{history.deposit_type}</td>
            <td className='text-nowrap'><img src={history.logo} alt="Method" style={{width: '20px'}} /> <span className='fw-bold text-nowrap'>{Number(history.amount).toFixed(5)} {history.symbol}</span></td>
            <td><span className={`${history.status === 'pending' ? 'status-warning' : history.status === 'failed' ? 'status-danger' : 'status-success'}`}>{history.status.charAt(0).toUpperCase() + history.status.slice(1)}</span></td>
            <td className="d-md-none d-table-cell"><div className="mycard px-2 py-1" onClick={() => setIsOpen(true)}><FontAwesomeIcon icon={faEye} style={{fontSize: '12px'}} /></div></td>
        </tr>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setIsOpen(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode1"
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-prime" style={{fontSize: '12px'}}>{history.type}</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
            </div>
            <div><img src={history.logo} alt="Method" style={{width: '20px'}} /> <span className='fw-bold text-nowrap'>{Number(history.amount).toFixed(5)} {history.symbol}</span></div>
            <hr/>
            <div className="d-flex align-items-center justify-content-between mb-2">
                <p className="mb-0 fw-bold">Date:</p>
                <p className="mb-0">{history.date}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between mb-2">
                <p className="mb-0 fw-bold">Reference:</p>
                <p className="mb-0">#{history.hash}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between mb-2">
                <p className="mb-0 fw-bold">Method:</p>
                <p className="mb-0">{history.method}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between mb-2">
                <p className="mb-0 fw-bold">Deposit Type:</p>
                <p className="mb-0">{history.deposit_type}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between mb-2">
                <p className="mb-0 fw-bold">Status:</p>
                <span className={`${history.status === 'pending' ? 'status-warning' : history.status === 'failed' ? 'status-danger' : 'status-success'}`}>{history.status.charAt(0).toUpperCase() + history.status.slice(1)}</span>
            </div>
        </Modal>
    </>
  )
}
export default DepositHistory